
export default superclass => class extends superclass  {
    stepToValue = {};

    deletePLockForStep(step) {
        delete this.stepToValue[step.id];
        step.pLockedParameters = step.pLockedParameters.filter(
            p => p !== this);
    }

    setPLockedValue(val) {
        this.selectedSteps.forEach(
            (step) => {
                if (!step.pLockedParameters.includes(this)) {
                    step.pLockedParameters.push(this);
                }
                this.stepToValue[step.id] = val;
            });
    }

    // sets the value for this parameter for a given step
    // if it has any p-locks for this step
    setForPLockedStep(step, time) {
        if (step.id in this.stepToValue) {
            if (this.savedUnlockedValue === undefined) {
                this.savedUnlockedValue = this.unlockedValue;
            }
            this.set(
                this.stepToValue[step.id],
                true,
                true,
                time);
            let ret = {};
            ret[this.id] = this.stepToValue[step.id];
            return ret;
        }
        return {};
    }

    get isCommandDown() {
        return this.state.keyboard.isCommandDown;
    }

    hasStepsSelected(requireCommandDown=true) {
        if (!this.store) {
            return false;
        }


        let steps = this.store.getState().keyboard.selectedPianoRollSteps;
        let track = this.context && this.context.track;
        let lfoTrack = this.context && this.context.lfoTrack;
        let envelopeTrack = this.context && this.context.envelopeTrack;
        let send = this.context && this.context.send;
        
        if (!steps || steps.length === 0) {
            return false;
        }

        if (requireCommandDown && !this.isCommandDown) {
            if (steps.some(x => x.id in this.stepToValue)) {
                return true;
            }
            return false;
        }

        let x = false;
        if (lfoTrack || envelopeTrack || send) {
            x = true;
        } else if (track) {
            x = steps.every(step => step && step.track === track);
        }
        return x;
    }

    get selectedSteps() {
        return this.store.getState().keyboard.selectedPianoRollSteps;
    }
}
